import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

export const GoHubTabs = withStyles({
  root: {
    overflow: "visible",
    background: "none !important",
    backgroundColor: "transparent !important",
  },
  flexContainer: {
    background: "none !important",
    backgroundColor: "transparent !important",
  },
  scroller: {
    background: "none !important",
    backgroundColor: "transparent !important",
  },
  indicator: {
    backgroundColor: "var(--color-edenred-brand-c-red, #F72717) !important",
    height: "2px !important",
    bottom: "0px !important",
  },
})((props) => <Tabs {...props} />);

export const GoHubTab = withStyles({
  root: {
    textTransform: "none !important",
    minWidth: "0 !important",
    padding: "16px 24px !important",
    fontWeight: "400 !important",
    fontSize: "16px !important",
    fontFamily: "'Ubuntu', Arial, sans-serif !important",
    color: "var(--types-and-elements-dark, #1E293B) !important",
    background: "none !important",
    backgroundColor: "transparent !important",
    borderBottom:
      "1px solid var(--types-and-elements-light, #E3E5E6) !important",
    opacity: "1 !important",
    "&:hover": {
      background: "none !important",
      backgroundColor: "transparent !important",
      opacity: "1 !important",
    },
    "&$selected": {
      color: "var(--color-edenred-brand-c-red, #F72717) !important",
      fontWeight: "700 !important",
      background: "none !important",
      backgroundColor: "transparent !important",
    },
  },
  wrapper: {
    background: "none !important",
    backgroundColor: "transparent !important",
  },
  selected: {},
})((props) => <Tab disableRipple disableFocusRipple {...props} />);
